<template>
  <v-app-bar elevation="0">
    <template v-slot:prepend>
    <v-app-bar-nav-icon v-if="$vuetify.display.smAndDown" variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <router-link to="/" class="text-decoration-none">
        <Logo/>
      </router-link>
    </template>
    <template v-slot:append>
      <v-menu location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn
              icon
              variant="text"
              v-bind="props"
              density="comfortable"
          >
            <v-avatar :image="currentLanguage.flag" size="24"></v-avatar>
          </v-btn>
        </template>
        <v-list min-width="150" max-width="250">
          <v-list-item
              link
              v-for="lang in languages"
              :key="lang.code"
              @click="changeLanguage(lang)"
          >
            <template v-slot:prepend>
              <v-avatar :image="lang.flag" size="24"></v-avatar>
            </template>
            <v-list-item-title>
              <div v-if="lang.code === locale">
                <b class="text-primary"> {{ lang.name }}</b>
              </div>
              <div v-else>
                {{ lang.name }}
              </div>

            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item lines>
            <v-list-item-subtitle class="text-wrap" style="font-size: 0.75rem;">
              * {{ $t('entities.language_notice') }}.
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-menu>

      <div
          v-if="!$vuetify.display.smAndDown"
          class="text-grey-darken-2 text-body-2 pl-3 pr-1"
      >
        {{ name }}
      </div>

      <v-menu :close-on-content-click="false" >
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text" icon size="large">
            <v-avatar size="38">
              <v-img :src="`https://is.mendelu.cz/lide/foto.pl?id=${uisId}`">
                <template v-slot:error>
                  <v-icon color="grey-lighten-2" icon="mdi-account" size="large"/>
                </template>
              </v-img>
            </v-avatar>
          </v-btn>
        </template>
        <v-card max-width="250" width="250" class="px-5 py-5 d-flex flex-column">
          <div class="d-flex ga-3 justify-center align-center my-5">
            <v-avatar size="50" color="">
              <v-img :src="`https://is.mendelu.cz/lide/foto.pl?id=${uisId}`">
                <template v-slot:error>
                  <v-icon color="grey-lighten-2" icon="mdi-account" size="large"/>
                </template>
              </v-img>
            </v-avatar>
            <div class="d-flex flex-column">
              <div class="text-grey-darken-2 text-body-2 text-break">{{ uisId }}, {{ username }} </div>
              <div class="text-subtitle-1 font-weight-medium text-grey-darken-3 text-break">{{ name }} </div>
            </div>
          </div>
          <v-btn @click="gdprDialogOpen = true" variant="text" color="primary" rounded class="mt-5">{{ $t('gamification.privacy_policy_settings_button') }}</v-btn>
          <v-btn class="mt-5" prepend-icon="power_settings_new" variant="outlined" rounded color="error" @click="doLogout">
            {{ $t('entities.logout') }}
          </v-btn>
        </v-card>
      </v-menu>
    </template>

    <v-dialog
        v-model="gdprDialogOpen"
        @after-enter="loadConsent"
        @after-leave="clearSettings"
        max-width="480"
    >
          <v-card
              class="pa-6"
          >
            <div class="d-flex justify-space-between align-start mb-4">
              <div>
                <div class="text-h6 font-weight-bold"> {{ $t('gamification.privacy_policy_headline') }} </div>
                <div class="text-body-2 text-grey-darken-1 mt-1">
                  {{ $t('gamification.privacy_policy_settings_headline') }}
                </div>
              </div>
              <v-btn
                  @click="gdprDialogOpen = false"
                  icon="close"
                  variant="text"
                  size="small"
                  color="grey-darken-1"
                  class="mt-n2 mr-n2"
              />
            </div>
            <div class="d-flex justify-space-between align-center ga-3">
              <div class="w-75">
                <div class="font-weight-bold text-body-1">
                  {{ $t('gamification.consent') }}
                </div>
                <div class="text-wrap text-body-2 text-grey-darken-1">
                  {{ $t('gamification.privacy_policy_settings') }}
                </div>
              </div>
              <div>
                <v-switch
                    v-model="consentCopy"
                    color="primary"
                    hide-details
                    inset
                    :loading="loading"
                ></v-switch>
              </div>
            </div>
            <div class="mb-8 mt-5">
              <a
                  class="text-grey-darken-2 text-caption text-decoration-underline"
                  target="_blank"
                  href="https://mendelu.cz/o-univerzite/uredni-deska/informace-o-zpracovani-osobnich-udaju-gdpr/"
              >
                {{ $t('gamification.privacy_policy_link_settings') }}
              </a>
            </div>

            <v-card-actions>
              <v-btn
                  variant="text"
                  rounded="pill"
                  class="px-6"
                  @click="gdprDialogOpen = false"
              >
                {{ $t('gamification.cancel') }}
              </v-btn>
              <v-spacer />
              <v-btn
                  color="primary"
                  variant="flat"
                  rounded="pill"
                  class="px-6 font-weight-bold"
                  :disabled="loading"
                  :loading="saving"
                  @click="saveSettings"
              >
                {{ $t('gamification.save_settings') }}
              </v-btn>
            </v-card-actions>
          </v-card>
    </v-dialog>

  </v-app-bar>

        <v-navigation-drawer
          id="app-drawer"
          v-model="drawer"
          border="0"
          :disable-resize-watcher="true"
        >
            <div class="flex-column">
                <v-list-item
                    v-for="(link, i) in filteredLinks"
                    :key="i"
                    :to="link.to"
                    class="v-list-item text-grey-darken-1 px-5"
                    @click="menuItemOnClick(link)"
                >
                    <div v-if="link.parent !== undefined" class="nested"></div>

                    <v-list-item-title class="ps-2 text-subtitle-2 d-flex align-center"  :class="link.parent !== undefined ? 'right-space' : ''">
                        <v-icon class="mr-3">{{ link.icon }}</v-icon>
                        <div>{{ link.text }}</div>
                    </v-list-item-title>

                    <template v-slot:append>
                      <v-chip size="small" color="red" variant="flat" v-if="link.notification">
                          {{ link.notification }}
                      </v-chip>
                    </template>

                </v-list-item>

            </div>
        </v-navigation-drawer>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Logo from "@/components/Logo.vue";
import czIcon from "@/assets/cz_icon.png"
import enIcon from "@/assets/en_icon.png"
import i18n from '../localization/i18n'

export default {

    name: 'LeftMenu',
    components: {Logo},

    data: () => {
        return {
            expandedItemId: null,
            drawer: true,
            expandedMenu: true,
            gdprDialogOpen: false,
            consentCopy: false,
            loading: true,
            saving: false,
            languages: [
                { code: 'cz', name: 'Čeština', flag: czIcon},
                { code: 'en', name: 'Angličtina', flag: enIcon}
            ],
          enInfo: false,
            //Forbid can be loaded from database in the future
            links: [
                {
                    name: 'reports',
                    to: '/auth/reports',
                    icon: 'message',
                    text: 'Problémy a nápady',
                    notification: 0
                },
                {
                    name: 'support',
                    to: '/auth/support',
                    icon: 'help_outline',
                    text:  'Helpdesk',
                },
                {
                    to: '/auth/warnings',
                    icon: 'warning',
                    text: 'Důležité zprávy',
                },
                {
                    to: '/auth/news',
                    icon: 'info',
                    text: 'Novinky',
                },
                {
                    to: '/auth/map',
                    icon: 'map',
                    text: 'Mapa',
                },
                {
                    path: '/mapwidget',
                    icon: 'my_location',
                    text: 'Mapový widget',
                },
                {
                    to: '/auth/study-department/reservation/calendar/detail',
                    icon: 'school',
                    text: 'Studijní oddělení',
                },
                {
                    to: '/auth/study-department/administration',
                    icon: 'web',
                    text: 'Správa studijního oddělení',
                },
                {
                    to: '/auth/displays',
                    icon: 'tv',
                    text: 'Informační panely',
                },
                {
                    to: '/auth/faq',
                    icon: 'question_answer',
                    text: 'Často kladené otázky',
                },
                {
                    to: '/auth/onboarding',
                    icon: 'explore',
                    text: 'Průvodce',
                },
                {
                    to: '/auth/gamification/dashboard',
                    icon: 'sports_esports',
                    text: 'Mendeluj!',
                },
                {
                    to: '/auth/graduates',
                    icon: 'school',
                    text: 'Absolventi',
                },
                // HIDDEN
                // {
                //     to: '/auth/iot/places',
                //     icon: 'view_stream',
                //     text: 'Smart University',
                // },
                // {
                //     to: '/auth/iot/beacons',
                //     icon: 'bluetooth',
                //     text: 'Majáky',
                // },
                {
                    to: '/auth/users',
                    icon: 'account_box',
                    text: 'Uživatelé',
                },
                {
                    to: '/auth/schedules',
                    icon: 'event_note',
                    text: 'Datumy semestru',
                },
                // ZAPŮJČKY / RENTS
                // {
                //     id: 'zapujcky',
                //     text: "Zápůjčky",
                //     icon: "content_paste",
                //     isGroup: true,
                // },
                // {
                //     to: '/auth/rent/my-rents',
                //     icon: 'content_paste',
                //     text: 'Moje zápůjčky',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/request/my-request',
                //     icon: 'note_alt',
                //     text: 'Moje žádosti',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/request/to-approve',
                //     icon: 'note_alt',
                //     text: 'Schvalování žádostí',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/rent/technician-rent',
                //     icon: 'note_alt',
                //     text: 'Zápůjčky techniky',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/groups',
                //     icon: 'account_box',
                //     text: 'Správa skupin užívatelů',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/technics/model-type',
                //     icon: 'devices',
                //     text: 'Správa skupin zařízení',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/technics/model',
                //     icon: 'devices',
                //     text: 'Správa modelů zařízení',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/technics/device',
                //     icon: 'devices',
                //     text: 'Správa zařízení',
                //     parent: 'zapujcky'
                // },
                // {
                //     to: '/auth/technics/model-type?technics=true',
                //     icon: 'devices',
                //     text: 'Přehled techniky',
                //     parent: 'zapujcky'
                // }
            ]
        }
    },

    created() {
       this.onResize();
    },

    mounted() {
        if (this.hasAccessToReports) {
          this.fetchPendingReportCount();
        }
    },

    watch: {
        getCountOfPendingReports(newValue) {
            this.reportsLink.notification = newValue;
        }
    },

    methods: {
        ...mapActions('reports', ['fetchReportCount']),
        ...mapActions('user', ['logout']),
        ...mapActions('ConsentGDPR',['getMyConsent','saveConsent','clear']),
        ...mapActions('Snackbar',['showErrorSnackbar']),

        doLogout() {
            if (this.isLoggedIn) {
                this.$auth.manuallyLogout();
            } else {
                this.$router.push({name: 'dashboard'});
            }

        },

        isActive(link) {
            return this.currentRoutePath.startsWith(link.to);
        },

        onResize() {
            this.drawer = window.innerWidth > 820;
        },

        menuItemOnClick(link) {
            if (link.path) window.open(this.$router.resolve({path: link.path}).href, '_blank');
            if (link.isGroup) {
                if (this.expandedItemId === link.id) {
                    this.expandedItemId = null;
                } else {
                    this.expandedItemId = link.id;
                }
            }
        },

        menuExpandCollapseOnClick() {
            if (this.drawer) {
                this.expandedMenu = !this.expandedMenu;
            }
        },

        fetchPendingReportCount() {
            // if currently not in Reports module, download the reports periodically
            if (this.$auth.isLoggedIn() && !this.isActive(this.reportsLink)) {
                this.fetchReportCount();
            }
            setTimeout(() => this.fetchPendingReportCount(), 60000);
        },

        changeLanguage(lang){
          i18n.global.locale.value = lang.code
          localStorage.setItem('locale', lang.code)
        },
        async loadConsent(){
          try {
            this.loading = true
            await this.getMyConsent()
          } catch (e) {
            console.log('error ', e)
          } finally {
            if(this.consent.id === null){
              this.consentCopy = false
            } else {
              this.consentCopy = this.consent.hasAccepted
            }
            this.loading = false
          }
        },
        clearSettings(){
          this.clear()
          this.loading = true
          this.saving = false
          this.consentCopy = false
        },
        async saveSettings(){
          try {
            this.saving = true
            await this.saveConsent({
              hasAccepted: this.consentCopy,
              web: this.consentCopy
            })
            this.gdprDialogOpen = false
          } catch (e) {
            await this.showErrorSnackbar('Něco se pokazilo')
          } finally {
            this.saving = false
          }
        }
    },

    computed: {
        ...mapGetters('reports', ['getCountOfPendingReports']),
        ...mapGetters('user', ['isLoggedIn', 'username', 'name', 'uisId']),
        ...mapGetters('ConsentGDPR',['consent']),

        filteredLinks() {
            return this.links.filter(link => {
                if (!link.to) return true;
                const route = this.$router.resolve({path: link.to});
                return (
                  (!link.parent || link.parent === this.expandedItemId) &&
                  this.$auth.canAccessRoute(route)
                );
            });
        },

        currentRoutePath() {
            return this.$route.path;
        },

        reportsLink() {
            return this.links.find(l => l.name === 'reports');
        },

        hasAccessToReports() {
            return this.filteredLinks.find(l => l.name === 'reports') !== undefined;
        },
        locale(){
            return i18n.global.locale.value
        },
        currentLanguage(){
          return this.languages.find(l => l.code === this.locale)
        }

    }
}
</script>

<style scoped>
@media only screen and (min-width: 960px) {
  nav.v-navigation-drawer {
    transform: translateX(0) !important;
  }
}

.cross {
    z-index: 999;
    height: 36px;
    width: 36px;
}

.sticky {
    left: 300px;
}

.v-list-item--active {
    background-color: var(--primary-color) !important;
    color: #FFF;
    border-radius: 0px 20px 20px 0px !important;
    text-decoration: none;
}

a.v-list-item--active {
    color: white !important;
    font-weight: bold;
}

.v-list-item:before {
    border-radius: 0px 20px 20px 0px !important;
}

.nested {
    margin: 6px 0px 6px 20px;
}

</style>
